import { bookService, projectService } from '@/services'
import router from '@/router'
import { nextIndex, generateHTML } from '@/core/helper-functions'
import localStorageService from '@/core/local-storage'
import { headquartersFirst } from '@/onboarding/defaultTeamProjects'

export default {
  state: () => ({
    books: [],
    bookMembers: [],
    book: null,
    trash: [],
    booksMemory: localStorageService.getItem('booksMemory') || {}
  }),

  getters: {
    hasBooks (state) {
      return state.books.length > 0
    }
  },

  mutations: {
    setBookProjects (state, value) {
      state.book.projects = value
    },

    setBooks (state, value) {
      state.books = value
    },

    setBook (state, value) {
      state.book = value
    },

    bookMembers (state, value) {
      state.bookMembers = value
    },

    saveBook (state, value) {
      state.books = state.books.map(book => {
        if (book.id === value.id) {
          return value
        } else {
          return book
        }
      })
    },

    setIconAndTitle (state, { projectId, icon, title }) {
      state.book.projects = state.book.projects.map(item => {
        if (item.id === projectId) return { ...item, icon, title }
        return item
      })
    },

    clearBook (state) {
      state.book = null
    },

    setDeletedBooks (state, value) {
      state.trash = value
    },

    setBooksMemory (state, value) {
      const memory = { ...state.booksMemory }
      memory[value.bookId] = value.projectId
      localStorageService.setItem('booksMemory', memory)

      state.booksMemory = memory
    }
  },

  actions: {
    getBooks ({ commit }) {
      commit('loading', true)
      return bookService.getBooks().then(({ data }) => {
        commit('setBooks', data.books)
        commit('toggleProjectsUpdate', true)
        return data.books
      })
    },

    getBook ({ commit, dispatch, getters, rootState }, id) {
      const settings = rootState.settings.settings

      return bookService.getById(id).then(({ data }) => {
        if (!data.book.projects.length) {
          if (getters.isHeadquarters(id)) {
            return projectService.add({
              bookId: id,
              title: 'Mission & vision',
              icon: 'orange-book',
              parentId: null,
              body: headquartersFirst(),
              html: generateHTML(headquartersFirst(), settings, 'Mission & vision')
            }).then(() => {
              commit('toggleProjectsUpdate', true)
              return dispatch('getBook', id)
            })
          }
          if (getters.allowAddProject) {
            // create new project
            return projectService.add({
              bookId: data.book.id,
              title: 'Page 1',
              icon: 'purple_circle',
              parentId: null,
              body: '<h1></h1>',
              html: generateHTML('<h1></h1>', settings, 'Page 1')
            }).then(() => {
              commit('toggleProjectsUpdate', true)
              return dispatch('getBook', id)
            })
          } else {
            commit('toggleLimitModal', { show: true, type: 'Pages' })
          }
        } else {
          commit('setBook', data.book)
          commit('updateChatMutedAt', data.book?.chat?.chatSetting?.mutedAt)
        }

        commit('bookMembers', data.members)
        return data.book
      }).catch(_ => router.push({ name: 'Books' }))
    },

    addBook ({ dispatch, commit, getters, state }) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      if (getters.allowAddBook) {
        commit('loading', true)
        const bookTitle = `Space #${nextIndex(state.books, 'Space', ' #')}`
        return bookService.create({
          title: bookTitle,
          subTitle: 'This is a space, let\'s add some pages to it.'
        })
          .then((res) => {
            return dispatch('getBooks').then(() => {
              dispatch('stats')
              return Promise.resolve(res.data.dataValues)
            })
          })
          .catch((err) => Promise.reject(err))
      } else {
        commit('toggleLimitModal', { show: true, type: 'Spaces' })
        return Promise.reject(new Error('Not allowed'))
      }
    },

    addSection ({ dispatch, commit, getters }) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      commit('loading', true)

      return bookService.createSection('New Section').then((res) => {
        return dispatch('getBooks').then(() => Promise.resolve(res.data.dataValues))
      })
    },

    deleteBook ({ dispatch, commit, getters }, { id, isSection }) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      commit('loading', true)
      return bookService.delete({ id, isSection }).then(() => {
        dispatch('getBooks')
        dispatch('stats')
      })
    },

    getDeletedBooks ({ commit, getters }) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      commit('loading', true)
      bookService.getDeleted().then(({ data }) => {
        commit('setDeletedBooks', data.books)
      })
    },

    editBook ({ commit, getters }, value) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      bookService.update(value)
        .then(() => commit('saveBook', value))
    },

    restoreBook ({ dispatch, getters, commit }, id) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      if (getters.allowAddBook) {
        return bookService.restore(id).then(() => {
          dispatch('getBooks')
          dispatch('stats')
          return Promise.resolve()
        })
      } else {
        commit('toggleLimitModal', { show: true, type: 'Spaces' })
      }
    }
  }
}
